import { Box } from '@mui/material'
import { WhatsNewItem } from './WhatsNewItem'
import { WhatsNewDocument } from './model/types'

type Props = {
  documents: WhatsNewDocument[]
}

export const WhatsNewList = ({ documents }: Props) => (
  <Box
    data-test="news-items"
    sx={{
      maxWidth: 300,
      overflowY: 'auto',
    }}
  >
    {documents.map((entry: WhatsNewDocument) => {
      const key = entry.id
      return <WhatsNewItem document={entry} key={key} />
    })}
  </Box>
)
